import React, { useState, useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" className="about" ref={sectionRef}>
      <div className="container">
        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="about-text">
            <h2 className="section-title">About</h2>
            <div className="title-underline"></div>
            <p className="about-description">
              AI/ML and signal processing engineer with 12+ years spanning research and product development. Published
              author and U.S. patent holder. Former officer and engineer in Unit 81, with experience building and
              leading applied algorithm teams. Deep expertise in Python and modern deep learning (vision, sequence
              models, RL), signal processing and communications, and practical hardware constraints from FPGA and
              real‑time systems.
            </p>
            <p className="about-description">
              Outside of work, I enjoy surfing and playing electric guitar and violin. I’m open to collaborations and
              research‑driven roles.
            </p>

            <h3 className="section-subtitle">Selected Highlights</h3>
            <ul className="about-list">
              <li>Machine Learning Engineer — General Motors (Computer Vision & Perception)</li>
              <li>Team Lead, Scene Understanding — Led algorithm engineers delivering perception features</li>
              <li>Applied Researcher — Reinforcement Learning, Transformers, Neural MCTS</li>
              <li>Senior Researcher — LEVL Technologies (RF fingerprinting)</li>
              <li>IDF Unit 81 — Algorithm engineer and R&D team lead; FPGA and real‑time signal processing</li>
            </ul>

            <div className="about-stats">
              <div className="stat">
                <h3 className="stat-number">12+</h3>
                <p className="stat-label">Years Experience</p>
              </div>
              <div className="stat">
                <h3 className="stat-number">Publications</h3>
                <p className="stat-label">IEEE TSP, OJSP</p>
              </div>
              <div className="stat">
                <h3 className="stat-number">Patent</h3>
                <p className="stat-label">
                  <a href="https://patents.google.com/patent/US20220399920A1/" target="_blank" rel="noopener noreferrer" className="patent-link">RF Fingerprinting (US20220399920A1)</a>
                </p>
              </div>
            </div>
          </div>

          <div className="about-image">
            <div className="image-wrapper">
              <div className="image-placeholder">
                <img src="/profile.jpg" alt="Noam Janco" className="profile-photo" />
              </div>
              <div className="image-bg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
